import { render, staticRenderFns } from "./SearchEngineSelector.vue?vue&type=template&id=64562826&scoped=true&"
import script from "./SearchEngineSelector.vue?vue&type=script&lang=js&"
export * from "./SearchEngineSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64562826",
  null
  
)

/* custom blocks */
import block0 from "./SearchEngineSelector.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports